import { z } from 'zod';

export enum AgentTypeEnum {
  Default = 1,
  CSVAgent = 2,
  Orchestration = 3,
}
export const agentTypeSchema = z.enum(AgentTypeEnum);
export type AgentType = z.infer<typeof agentTypeSchema>;

export const getAgentTypeName = (typeId: AgentTypeEnum) => {
  return {
    [AgentTypeEnum.Default]: 'Legacy',
    [AgentTypeEnum.CSVAgent]: 'CSV Agent',
    [AgentTypeEnum.Orchestration]: 'Default',
  }[typeId];
};

export enum AgentProtocolEnum {
  HTTP = 1,
  MCP = 2,
  A2A = 3,
  Internal = 4,
}
export const agentProtocolSchema = z.enum(AgentProtocolEnum);
export type AgentProtocol = z.infer<typeof agentProtocolSchema>;

export const getAgentProtocolName = (protocolId: AgentProtocolEnum) => {
  return {
    [AgentProtocolEnum.HTTP]: 'HTTP',
    [AgentProtocolEnum.MCP]: 'MCP',
    [AgentProtocolEnum.A2A]: 'A2A',
    [AgentProtocolEnum.Internal]: 'Internal',
  }[protocolId];
};

export enum AgentIdentifier {
  BrandInsights = 'bi-agent',
}

export const OpenAIChatModelSchema = z.enum([
  'gpt-5.2-chat',
  'gpt-5.3-chat',
  'gpt-5.4',
  'gpt-5.4-mini',
  'gpt-5.4-nano',
  'gpt-4o',
  'gpt-4o-mini',
  'gpt-4.1-mini',
  'gpt-4.1',
  'gpt-5-mini',
  'gpt-5.5',
  'gpt-5.6-terra',
  'gpt-5.6-sol',
  'gpt-5.6-luna',
]);
export type OpenAIChatModel = z.infer<typeof OpenAIChatModelSchema>;

export const AnthropicChatModelSchema = z.enum(['claude-sonnet-4.5', 'claude-sonnet-4.6']);
export type AnthropicChatModel = z.infer<typeof AnthropicChatModelSchema>;

export const AgentChatModelSchema = z.union([OpenAIChatModelSchema, AnthropicChatModelSchema]);
export type AgentChatModel = z.infer<typeof AgentChatModelSchema>;

export const AgentChatModelProviderSchema = z.enum(['openai', 'anthropic']);
export type AgentChatModelProvider = z.infer<typeof AgentChatModelProviderSchema>;
